import { createSlice } from "@reduxjs/toolkit";

import {
  addNewDocumentData,
  deleteDocument,
  fetchDocumentList,
  fetchDocumentTypeList,
  updateDocument,
} from "../thunks/documents";

import type { Document, DocumentType } from "../../utils/types/document";

interface DocumentListState {
  documentList: {
    [key: string]: {
      data: Document[];
      // total: number;
    };
  };
  documentTypeList: DocumentType[];
  loading: boolean;
  error: string | null;
}

const initialState: DocumentListState = {
  documentList: {},
  documentTypeList: [],
  loading: false,
  error: null,
};

export const documentListSlice = createSlice({
  name: "document",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocumentList.fulfilled, (state, action) => {
        // Initialize the entry if it doesn't exist
        if (!state.documentList[action.payload.id]) {
          state.documentList[action.payload.id] = { data: []};
        }
        state.documentList[action.payload.id].data = action.payload.data.data;
        // state.documentList[action.payload.id].total = action.payload.data.total;
        state.loading = false;
      })
      .addCase(fetchDocumentList.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });

    builder
      .addCase(fetchDocumentTypeList.fulfilled, (state, action) => {
        state.documentTypeList = action.payload || [];
        // state.loading = false;
      })
      .addCase(fetchDocumentTypeList.rejected, (state, action) => {
        state.error = action.payload as string;
        // state.loading = false;
      });

    builder
      .addCase(updateDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDocument.fulfilled, (state, action) => {
        state.loading = false;
        // Check if the entry exists before trying to update it
        if (state.documentList[action.payload.id]) {
          state.documentList[action.payload?.id].data = state.documentList[
            action.payload?.id
          ].data.map((document) => {
            if (document.documentId === action.payload?.data?.documentId) {
              return { ...document, ...action.payload?.data };
            }
            return document;
          });
        }
      })
      .addCase(updateDocument.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDocument.fulfilled, (state, action) => {
        state.loading = false;
        // Check if the entry exists before trying to filter and update it
        if (state.documentList[action.payload?.jobId]) {
          state.documentList[action.payload.jobId].data = state.documentList[
            action.payload.jobId
          ].data.filter(
            (document) => document.documentId !== action.payload?.id
          );
          // state.documentList[action.payload.jobId].total -= 1;
        }
      })
      .addCase(deleteDocument.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewDocumentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewDocumentData.fulfilled, (state, action) => {
        state.loading = false;
        // Initialize the entry if it doesn't exist
        if (!state.documentList[action.payload.jobId]) {
          state.documentList[action.payload.jobId] = { data: []};
        }
        state.documentList[action.payload.jobId].data = [
          action.payload.data,
          ...state.documentList[action.payload.jobId].data,
        ];
        // state.documentList[action.payload.jobId].total += 1;
      })
      .addCase(addNewDocumentData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
  },
});

export default documentListSlice.reducer;
